import { useState } from "react";
import { Language } from "../utils/dictionary";

const content = {
  [Language.SPANISH]: {
    title: "Politica de Privacidad",
    lastUpdated: "Ultima actualizacion: 7 de abril de 2026",
    sections: [
      {
        title: "1. Introduccion",
        body: `FLUXI ("nosotros", "nuestro") opera la plataforma de comercio electronico accesible en app.fluxi.co. Esta politica describe como recopilamos, usamos y protegemos tu informacion personal, incluyendo las interacciones a traves de WhatsApp Business.`,
      },
      {
        title: "2. Informacion que recopilamos",
        body: null,
        list: [
          "Datos de contacto: nombre, apellido, correo electronico, numero de telefono",
          "Datos de envio: direccion, ciudad, departamento, barrio",
          "Datos de pedidos: productos, cantidades, precios, metodo de pago",
          "Datos de comunicacion via WhatsApp: mensajes enviados y recibidos relacionados con la confirmacion y seguimiento de pedidos",
          "Datos de uso: interacciones con la plataforma, estado de entrega",
        ],
      },
      {
        title: "3. Como usamos tu informacion",
        body: null,
        list: [
          "Procesar y confirmar pedidos de compra",
          "Enviar notificaciones de estado de pedido via WhatsApp",
          "Proporcionar informacion de seguimiento de envios",
          "Atender consultas y soporte al cliente",
          "Mejorar nuestros servicios y experiencia de usuario",
        ],
      },
      {
        title: "4. Comunicaciones via WhatsApp",
        body: "Utilizamos la API de WhatsApp Business para:",
        list: [
          "Enviar confirmaciones de pedido",
          "Recibir respuestas de confirmacion o cancelacion",
          "Notificar actualizaciones de envio y tracking",
          "Responder consultas sobre pedidos",
        ],
        footer:
          "Los mensajes son procesados de forma automatizada para gestionar tus pedidos de manera eficiente.",
      },
      {
        title: "5. Comparticion de datos",
        body: "Compartimos tu informacion unicamente con:",
        list: [
          "Meta/WhatsApp: para el envio y recepcion de mensajes",
          "Proveedores de pago (Stripe, MercadoPago): para procesar pagos",
          "Proveedores de logistica: para la entrega de productos",
        ],
        footer:
          "No vendemos ni compartimos tu informacion con terceros para fines publicitarios.",
      },
      {
        title: "6. Seguridad de datos",
        body: null,
        list: [
          "Las comunicaciones via WhatsApp estan cifradas de extremo a extremo",
          "Utilizamos protocolos HTTPS para todas las transmisiones de datos",
          "El acceso a los datos esta restringido a personal autorizado",
          "Almacenamos los datos en servidores seguros con controles de acceso",
        ],
      },
      {
        title: "7. Retencion de datos",
        body: null,
        list: [
          "Datos de pedidos: retenidos mientras sea necesario para cumplir con obligaciones legales y comerciales",
          "Historial de mensajes de WhatsApp: retenido por el periodo necesario para completar la transaccion y soporte post-venta",
        ],
      },
      {
        title: "8. Tus derechos",
        body: "Tienes derecho a:",
        list: [
          "Acceder a tu informacion personal",
          "Solicitar la correccion de datos inexactos",
          "Solicitar la eliminacion de tus datos",
          "Retirar tu consentimiento para comunicaciones",
          "Presentar una queja ante la autoridad de proteccion de datos",
        ],
      },
      {
        title: "9. Contacto",
        body: "Para consultas sobre privacidad: tech@fluxi.co",
      },
    ],
  },
  [Language.ENGLISH]: {
    title: "Privacy Policy",
    lastUpdated: "Last updated: April 7, 2026",
    sections: [
      {
        title: "1. Introduction",
        body: `FLUXI ("we", "our") operates the e-commerce platform accessible at app.fluxi.co. This policy describes how we collect, use, and protect your personal information, including interactions through WhatsApp Business.`,
      },
      {
        title: "2. Information We Collect",
        body: null,
        list: [
          "Contact data: name, last name, email address, phone number",
          "Shipping data: address, city, state/department, neighborhood",
          "Order data: products, quantities, prices, payment method",
          "WhatsApp communication data: messages sent and received related to order confirmation and tracking",
          "Usage data: platform interactions, delivery status",
        ],
      },
      {
        title: "3. How We Use Your Information",
        body: null,
        list: [
          "Process and confirm purchase orders",
          "Send order status notifications via WhatsApp",
          "Provide shipping tracking information",
          "Handle customer inquiries and support",
          "Improve our services and user experience",
        ],
      },
      {
        title: "4. WhatsApp Communications",
        body: "We use the WhatsApp Business API to:",
        list: [
          "Send order confirmations",
          "Receive confirmation or cancellation responses",
          "Notify shipping and tracking updates",
          "Respond to order-related inquiries",
        ],
        footer:
          "Messages are processed automatically to manage your orders efficiently.",
      },
      {
        title: "5. Data Sharing",
        body: "We share your information only with:",
        list: [
          "Meta/WhatsApp: for sending and receiving messages",
          "Payment providers (Stripe, MercadoPago): for payment processing",
          "Logistics providers: for product delivery",
        ],
        footer:
          "We do not sell or share your information with third parties for advertising purposes.",
      },
      {
        title: "6. Data Security",
        body: null,
        list: [
          "WhatsApp communications are end-to-end encrypted",
          "We use HTTPS protocols for all data transmissions",
          "Data access is restricted to authorized personnel",
          "Data is stored on secure servers with access controls",
        ],
      },
      {
        title: "7. Data Retention",
        body: null,
        list: [
          "Order data: retained as long as necessary to comply with legal and commercial obligations",
          "WhatsApp message history: retained for the period necessary to complete the transaction and post-sale support",
        ],
      },
      {
        title: "8. Your Rights",
        body: "You have the right to:",
        list: [
          "Access your personal information",
          "Request correction of inaccurate data",
          "Request deletion of your data",
          "Withdraw your consent for communications",
          "File a complaint with the data protection authority",
        ],
      },
      {
        title: "9. Contact",
        body: "For privacy inquiries: tech@fluxi.co",
      },
    ],
  },
  [Language.PORTUGUESE]: {
    title: "Politica de Privacidade",
    lastUpdated: "Ultima atualizacao: 7 de abril de 2026",
    sections: [
      {
        title: "1. Introducao",
        body: `FLUXI ("nos", "nosso") opera a plataforma de comercio eletronico acessivel em app.fluxi.co. Esta politica descreve como coletamos, usamos e protegemos suas informacoes pessoais, incluindo interacoes atraves do WhatsApp Business.`,
      },
      {
        title: "2. Informacoes que coletamos",
        body: null,
        list: [
          "Dados de contato: nome, sobrenome, endereco de e-mail, numero de telefone",
          "Dados de envio: endereco, cidade, estado, bairro",
          "Dados de pedidos: produtos, quantidades, precos, metodo de pagamento",
          "Dados de comunicacao via WhatsApp: mensagens enviadas e recebidas relacionadas a confirmacao e rastreamento de pedidos",
          "Dados de uso: interacoes com a plataforma, status de entrega",
        ],
      },
      {
        title: "3. Como usamos suas informacoes",
        body: null,
        list: [
          "Processar e confirmar pedidos de compra",
          "Enviar notificacoes de status do pedido via WhatsApp",
          "Fornecer informacoes de rastreamento de envio",
          "Atender consultas e suporte ao cliente",
          "Melhorar nossos servicos e experiencia do usuario",
        ],
      },
      {
        title: "4. Comunicacoes via WhatsApp",
        body: "Utilizamos a API do WhatsApp Business para:",
        list: [
          "Enviar confirmacoes de pedido",
          "Receber respostas de confirmacao ou cancelamento",
          "Notificar atualizacoes de envio e rastreamento",
          "Responder consultas sobre pedidos",
        ],
        footer:
          "As mensagens sao processadas de forma automatizada para gerenciar seus pedidos de maneira eficiente.",
      },
      {
        title: "5. Compartilhamento de dados",
        body: "Compartilhamos suas informacoes apenas com:",
        list: [
          "Meta/WhatsApp: para envio e recepcao de mensagens",
          "Provedores de pagamento (Stripe, MercadoPago): para processamento de pagamentos",
          "Provedores de logistica: para entrega de produtos",
        ],
        footer:
          "Nao vendemos nem compartilhamos suas informacoes com terceiros para fins publicitarios.",
      },
      {
        title: "6. Seguranca de dados",
        body: null,
        list: [
          "As comunicacoes via WhatsApp sao criptografadas de ponta a ponta",
          "Utilizamos protocolos HTTPS para todas as transmissoes de dados",
          "O acesso aos dados e restrito a pessoal autorizado",
          "Os dados sao armazenados em servidores seguros com controles de acesso",
        ],
      },
      {
        title: "7. Retencao de dados",
        body: null,
        list: [
          "Dados de pedidos: retidos enquanto necessario para cumprir obrigacoes legais e comerciais",
          "Historico de mensagens do WhatsApp: retido pelo periodo necessario para completar a transacao e suporte pos-venda",
        ],
      },
      {
        title: "8. Seus direitos",
        body: "Voce tem o direito de:",
        list: [
          "Acessar suas informacoes pessoais",
          "Solicitar a correcao de dados inexatos",
          "Solicitar a exclusao de seus dados",
          "Retirar seu consentimento para comunicacoes",
          "Apresentar uma reclamacao a autoridade de protecao de dados",
        ],
      },
      {
        title: "9. Contato",
        body: "Para consultas sobre privacidade: tech@fluxi.co",
      },
    ],
  },
};

interface Section {
  title: string;
  body?: string | null;
  list?: string[];
  footer?: string;
}

const PrivacyPolicyPage = () => {
  const [lang, setLang] = useState<Language>(Language.SPANISH);
  const data = content[lang];

  return (
    <div className="min-h-screen bg-white">
      <div className="mx-auto max-w-3xl px-6 py-12">
        <div className="mb-8 flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">{data.title}</h1>
            <p className="mt-1 text-sm text-gray-500">{data.lastUpdated}</p>
          </div>
          <div className="flex gap-1 rounded-lg bg-gray-100 p-1">
            {[
              { key: Language.SPANISH, label: "ES" },
              { key: Language.ENGLISH, label: "EN" },
              { key: Language.PORTUGUESE, label: "PT" },
            ].map(({ key, label }) => (
              <button
                key={key}
                onClick={() => setLang(key)}
                className={`rounded-md px-3 py-1 text-sm font-medium transition-colors ${
                  lang === key
                    ? "bg-white text-gray-900 shadow-sm"
                    : "text-gray-500 hover:text-gray-700"
                }`}
              >
                {label}
              </button>
            ))}
          </div>
        </div>

        <div className="space-y-8">
          {data.sections.map((section: Section) => (
            <div key={section.title}>
              <h2 className="mb-3 text-xl font-semibold text-gray-900">
                {section.title}
              </h2>
              {section.body && (
                <p className="mb-2 leading-relaxed text-gray-700">
                  {section.body}
                </p>
              )}
              {section.list && (
                <ul className="ml-6 list-disc space-y-1">
                  {section.list.map((item, i) => (
                    <li key={i} className="leading-relaxed text-gray-700">
                      {item}
                    </li>
                  ))}
                </ul>
              )}
              {section.footer && (
                <p className="mt-2 leading-relaxed text-gray-700">
                  {section.footer}
                </p>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 border-t border-gray-200 pt-6 text-center text-sm text-gray-400">
          FLUXI &copy; {new Date().getFullYear()}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
